import { Message } from '@ipfabric/ui-components/Message/Message';

export const OLDER_SNAPSHOT_ASSIGNMENT_NOTICE =
  'This is an older snapshot. For changes that should stick, use the latest snapshot when you can. If you apply changes to future snapshots from here, they may not match what you see on screen — labeling for these targets may have been updated since this snapshot was taken.';

export const OlderSnapshotAssignmentNotice = () => (
  <div data-testid='older-snapshot-assignment-notice'>
    <Message
      message={OLDER_SNAPSHOT_ASSIGNMENT_NOTICE}
      type='warning'
      variant='plain'
    />
  </div>
);
